import React from 'react';
import { motion } from 'framer-motion';

const TestimonialsSection = () => {
  const testimonials = [
    {
      quote: "L\'expertise du cabinet a été le catalyseur de notre restructuration. Leur approche de la \'Thérapie d\'Entreprise\' a restauré une culture de performance durable.",
      author: "Dr. Amadou Diallo",
      position: "Directeur de la Transformation",
      org: "Banque Panafricaine d\'Investissement",
      color: "#96121D"
    },
    {
      quote: "Une révolution dans notre gestion de projets numériques. Le CRF Perfection ne se contente pas de conseiller, il livre des résultats opérationnels tangibles.",
      author: "Mme Sarah Mensah",
      position: "Commissaire aux Grands Travaux",
      org: "Ministère de l\'Économie Numérique",
      color: "#9B8E57"
    },
    {
      quote: "Le programme de formation certifiant a transformé notre top management. Nous parlons désormais le langage de l'excellence mondiale et de l'innovation IA.",
      author: "Jean-Pierre Kouamé",
      position: "DRH Groupe",
      org: "Leader Régional de l\'Énergie",
      color: "#96121D"
    }
  ];

  return (
    <section className="py-20 bg-[#F9FAFB] relative overflow-hidden">
      {/* Background patterns */}
      <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-[#9B8E57]/5 rounded-full -translate-y-1/2 translate-x-1/2 blur-[100px]" />
      <div className="absolute bottom-0 left-0 w-1/3 h-1/3 bg-[#96121D]/5 rounded-full translate-y-1/2 -translate-x-1/2 blur-[100px]" />
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-20">
          <motion.span 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            className="text-[#9B8E57] font-bold tracking-[0.2em] uppercase text-sm mb-4 block"
          >
            Succès Partagés
          </motion.span>
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6"
          >
            La voix de nos <span className="text-[#96121D]">partenaires</span>
          </motion.h2>
          <div className="w-16 h-1.5 bg-[#96121D] mx-auto rounded-full" />
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials?.map((t, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2 }}
              viewport={{ once: true }}
              className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 flex flex-col justify-between hover:shadow-xl transition-all duration-300 relative group"
            >
              <div className="absolute top-0 left-10 transform -translate-y-1/2">
                <div className="bg-white p-2 rounded-full shadow-md">
                   <svg className="w-8 h-8 text-[#9B8E57]" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
                  </svg>
                </div>
              </div>

              <p className="text-gray-600 italic leading-relaxed mb-8 pt-4">
                "{t?.quote}"
              </p>

              <div className="flex items-center space-x-4 border-t border-gray-50 pt-6">
                <div className="h-12 w-12 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0 border-2 border-[#9B8E57]/20">
                  <span className="text-[#96121D] font-bold">{t?.author?.charAt(0)}</span>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-sm">{t?.author}</h4>
                  <p className="text-[#9B8E57] text-[11px] font-bold uppercase tracking-wider">{t?.position}</p>
                  <p className="text-gray-400 text-[10px] leading-tight mt-0.5">{t?.org}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Global Metric */}
        <motion.div 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          className="mt-20 flex flex-wrap justify-center gap-12 border-t border-gray-200 pt-12"
        >
          <div className="text-center">
            <div className="text-3xl font-black text-gray-900">98%</div>
            <div className="text-xs font-bold text-[#9B8E57] uppercase tracking-widest mt-1">Taux de Satisfaction</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-black text-gray-900">150+</div>
            <div className="text-xs font-bold text-[#9B8E57] uppercase tracking-widest mt-1">Missions Réussies</div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TestimonialsSection;